export default __webpack_public_path__ + "static/media/share-ios.2a4438cf83485e55070f5d23174920b1.svg";